import { render, staticRenderFns } from "./TheroyDetail.vue?vue&type=template&id=3d54c424&scoped=true&"
import script from "./TheroyDetail.vue?vue&type=script&lang=js&"
export * from "./TheroyDetail.vue?vue&type=script&lang=js&"
import style0 from "./TheroyDetail.vue?vue&type=style&index=0&id=3d54c424&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54c424",
  null
  
)

export default component.exports